module.exports = __webpack_public_path__ + "img/homePad_logo_dark.f1b9c020.svg";